import { client } from './client';

// --- Invoices ---

export const getAllInvoices = async (params = {}) => {
    const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v != null && v !== '')
    );
    const response = await client.get('/v1/invoices', { params: cleanParams });
    return response.data; // { items, pagination }
};

export const getInvoicesByService = async (serviceUid, params = {}) => {
    const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v != null && v !== '')
    );
    const response = await client.get(`/v1/services/${serviceUid}/invoices`, { params: cleanParams });
    return response.data; // { items, pagination }
};

export const createInvoice = async (serviceUid, data) => {
    const response = await client.post(`/v1/services/${serviceUid}/invoices`, data);
    return response.data;
};

export const updateInvoice = async (invoiceUid, data) => {
    const response = await client.put(`/v1/invoices/${invoiceUid}`, data);
    return response.data;
};

export const deleteInvoice = async (invoiceUid) => {
    const response = await client.delete(`/v1/invoices/${invoiceUid}`);
    return response.data;
};
